import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import policyDocument from "./policyDocumentService";

const initialState = {
  policyDocuments: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

// ✅ Create
export const createPolicyDocument = createAsyncThunk(
  "policyDocument/create",
  async (itemData, thunkAPI) => {
    try {
      return await policyDocument.createPolicyDocument(itemData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// ✅ Get All
export const getPolicyDocuments = createAsyncThunk(
  "policyDocument/getAll",
  async (_, thunkAPI) => {
    try {

      return await policyDocument.getPolicyDocuments();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPolicyDocumentByUuid = createAsyncThunk(
  "policyDocument/getByUuid",
  async (uuid, thunkAPI) => {
    try {

      return await policyDocument.getPolicyDocumentByUuid(uuid);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


// ✅ Delete
export const deletePolicyDocument = createAsyncThunk(
  "policyDocument/delete",
  async (id, thunkAPI) => {
    try {
      return await policyDocument.deletePolicyDocument(id,);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// ✅ Update
export const updatePolicyDocument = createAsyncThunk(
  "policyDocument/update",
  async ({ id, newData }, thunkAPI) => {
    try {
      return await policyDocument.updatePolicyDocument(id, newData,);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// ✅ Slice
export const policyDocumentSlice = createSlice({
  name: "policyDocument",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createPolicyDocument.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPolicyDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(createPolicyDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get All
      .addCase(getPolicyDocuments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicyDocuments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.policyDocuments = action.payload.data;
      })
      .addCase(getPolicyDocuments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getPolicyDocumentByUuid.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicyDocumentByUuid.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.policyDocuments = action.payload.data;
      })
      .addCase(getPolicyDocumentByUuid.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Delete
      .addCase(deletePolicyDocument.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletePolicyDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.policyDocuments = state.policyDocuments.filter(
          (item) => item._id !== action.payload.id
        );
      })
      .addCase(deletePolicyDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Update
      .addCase(updatePolicyDocument.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePolicyDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(updatePolicyDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = policyDocumentSlice.actions;
export default policyDocumentSlice.reducer;
